// extracted by css-extract-rspack-plugin
export default {"defaultSize":"iDghD","disabled":"QMxQ3","hoverWithBackground":"OJg9I"};